<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    Gain access to '{{ register.name }}'
  </h4>

  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="modal.dismiss('exit')"
  ></button>
</div>

<div class="modal-body">
  <p>It appears that you do not have access to {{ register.name }}.</p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline" (click)="modal.dismiss('exit')">
    Cancel
  </button>

  <button type="button" class="btn btn-primary me-2" (click)="grantAccess()">
    Grant Access
  </button>
</div>
